import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AssignableUserView } from '../../api/generated/models/AssignableUserView';
import AssigneePicker from './AssigneePicker';

interface TaskAssigneesFieldProps {
  members: AssignableUserView[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}

/** Shared assignee multi-select for task create/edit forms. */
const TaskAssigneesField: React.FC<TaskAssigneesFieldProps> = ({
  members,
  selectedIds,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tasks-form-field tasks-form-assignees">
      <span className="tasks-form-label" id="task-form-assignees-label">
        {t('tasks_assignees')}
      </span>
      <AssigneePicker
        members={members}
        selectedIds={selectedIds}
        onChange={onChange}
        disabled={disabled}
        ariaLabelledBy="task-form-assignees-label"
      />
    </div>
  );
};

export default TaskAssigneesField;
